import {
  Permission,
  PermissionsConfig
} from "@/common/types/permissions.types";

/**
 * Transforma um array de permissões em um objeto de configuração de permissões
 * agrupado por escopo e módulo, removendo ações duplicadas.
 *
 * @param permissions - Array de permissões contendo escopo, módulo e ações
 * @returns Objeto de configuração de permissões organizado hierarquicamente
 */
export function transformPermissions(
  permissions: Permission[]
): PermissionsConfig {
  const permissionsByScope: Partial<PermissionsConfig> = {};

  for (const { scope, module, actions } of permissions) {
    if (!permissionsByScope[scope]) {
      permissionsByScope[scope] = {};
    }

    if (!permissionsByScope[scope][module]) {
      permissionsByScope[scope][module] = [];
    }

    const existing = permissionsByScope[scope][module];

    for (const action of actions) {
      if (!existing.includes(action)) {
        existing.push(action);
      }
    }
  }

  return permissionsByScope;
}
